import { UserManager } from "oidc-client-ts";
import { AppRouter } from "../appConfig";
import { Apis } from "../network/apis";
import { AppStore } from "../store";
import { AttachDocumentFilesService } from "./documents/AttachDocumentFilesService";
import { CreateDocumentAndAttachFilesService } from "./documents/CreateDocumentAndAttachFilesService";
import { DeleteDocumentService } from "./documents/DeleteDocumentService";
import { DownloadDocumentFileService } from "./documents/DownloadDocumentFileService";
import { RemoveDocumentFilesService } from "./documents/RemoveDocumentFilesService";
import { UpdateDocumentService } from "./documents/UpdateDocumentService";
import { EditUserService } from "./editUserService";
import { SendSharingTokenByMailService } from "./SendSharingTokenByMailService";
import { Service, ServicePayload } from "./service";
import { ShareHealthRecordsService } from "./ShareHealthRecordsService";
import { SignInService } from "./signInService";
import { SignOutService } from "./signOutService";
import { IframeAuthenticationService } from "./iframeAuthenticationService";
import { CreateVaccinationActService } from "./CreateVaccinationActService";
import { UpdateVaccinationActService } from "./UpdateVaccinationActService";
import { CreateTravelService } from "./travel/CreateTravelService";
import { DeleteTravelService } from "./travel/DeleteTravelService";
import { ListTravelsService } from "./travel/ListTravelsService";
import { UpdateTravelService } from "./travel/UpdateTravelService";

type ServiceCollection = {
  // We don't care about the return type of the service here
  [key: string]: Service<ServicePayload, any>;
};

export interface Services extends ServiceCollection {
  signIn: SignInService;
  signOut: SignOutService;
  editUser: EditUserService;
  shareHealthRecords: ShareHealthRecordsService;
  sendSharingTokenByMail: SendSharingTokenByMailService;
  createDocumentAndAttachFiles: CreateDocumentAndAttachFilesService;
  deleteDocument: DeleteDocumentService;
  updateDocument: UpdateDocumentService;
  downloadDocumentFile: DownloadDocumentFileService;
  attachDocumentFiles: AttachDocumentFilesService;
  removeDocumentFiles: RemoveDocumentFilesService;
  iframeAuthentication: IframeAuthenticationService;
  createVaccinationAct: CreateVaccinationActService;
  updateVaccinationAct: UpdateVaccinationActService;
  listTravels: ListTravelsService;
  createTravel: CreateTravelService;
  updateTravel: UpdateTravelService;
  deleteTravel: DeleteTravelService;
}

interface ServiceDependencies {
  store: AppStore;
  oidcManager: UserManager;
  router: AppRouter;
  apis: Apis;
}

export function initServices({ store, oidcManager, router, apis }: ServiceDependencies): Services {
  return {
    signIn: new SignInService(store, window, oidcManager, router),
    signOut: new SignOutService(window, oidcManager),
    editUser: new EditUserService(window, oidcManager),
    shareHealthRecords: new ShareHealthRecordsService(apis, router),
    sendSharingTokenByMail: new SendSharingTokenByMailService(apis.recordSharingApi),
    createDocumentAndAttachFiles: new CreateDocumentAndAttachFilesService(apis),
    deleteDocument: new DeleteDocumentService(apis),
    updateDocument: new UpdateDocumentService(apis),
    downloadDocumentFile: new DownloadDocumentFileService(apis),
    attachDocumentFiles: new AttachDocumentFilesService(apis),
    removeDocumentFiles: new RemoveDocumentFilesService(apis),
    iframeAuthentication: new IframeAuthenticationService(window, oidcManager),
    createVaccinationAct: new CreateVaccinationActService(apis.vaccinationActApi),
    updateVaccinationAct: new UpdateVaccinationActService(apis.vaccinationActApi),
    listTravels: new ListTravelsService(apis.healthRecordApi),
    createTravel: new CreateTravelService(apis.travelApi),
    updateTravel: new UpdateTravelService(apis.travelApi),
    deleteTravel: new DeleteTravelService(apis.travelApi),
  };
}
